import { TaxrateDto } from '@symphony-solo/domain/taxrates/src';
import { TransactionProductUnitPrice } from '.';

export class TransactionProduct {
  public id: number;
  public name: string;
  public price: TransactionProductUnitPrice;
  public taxRate: TaxrateDto;
  public taxAmount: number;
  public quantity: number;
  public lineIsCorrected: boolean;
  public lineNo: number;

  constructor() {
    this.id = null;
    this.name = null;
    this.price = null;
    this.taxRate = null;
    this.taxAmount = null;
    this.quantity = null;
    this.lineIsCorrected = false;
    this.lineNo = null;
  }
}
